import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { QpInfoComponent } from './qp-info.component';
import { QpRoutingModule } from './qp-info-routing.module';
@NgModule({
  declarations: [QpInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MyDatePickerModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    DropDownListAllModule,
    QpRoutingModule,
    dropdownModule
  ],
    exports: [
    QpInfoComponent  // ← MAKE SURE THIS LINE EXISTS
  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService,ResizeService],
})
export class QpInfoModule { }
